import instance from '@/store/api/instance';

export let CpDashCodeReportRead = function (data) {
    return instance.post('/cpdash/code/report/read', data)
}

export let CpDashCodeReportExport = function (data) {
    return instance.post('/cpdash/code/report/export', data)
}